export default async () => {

    const { default: Swiper } = await import('swiper')
    const { Autoplay } = await import('swiper/modules')


    const swiper = new Swiper('.anim-words', {
        modules: [Autoplay],
        direction: 'vertical',
        slidesPerView: 4.5,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
    });
}; 